/**
 * Created by ferasmasood on 8/14/17.
 */
(function () {

    "use strict";

    var app = angular.module('harriApp');

    app.directive('globalSearch', ['$state', 'hUser', function ($state, hUser) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: "../scripts/global-directives/global_search/global_search.html",
            scope: {
                usedInHeader: '=',
                onViewReady: '&',
                searchDropdownToggeled: '&',
                onFocusChange: '&'
            },
            link: function (scope, element, attrs) {

                var KEYS = {};
                KEYS.ENTER = 13;
                KEYS.UP = 38;
                KEYS.DOWN = 40;
                KEYS.ESC = 27;

                scope.hideResult = false;

                $(document).click(function () {
                    scope.hideResult = true;
                    scope.inputOnFocus = false;
                    showResultsDropdown(false);
                    setTimeout(function () {
                        scope.$digest();
                    }, 1)
                });

                $(".global-search-wrapper").click(function (event) {
                    scope.hideResult = false;
                    scope.inputOnFocus = true;

                    showResultsDropdown(scope.searchInput && scope.searchInput.length >= 3);

                    event.stopPropagation();
                    scope.$digest();
                });
                var searchTimeOutPeriod = 250;
                var whilePrintingTimeOutPeriod = 1000;
                var lastSearchPhrase = "";
                var resultIndex = -1;
                var getSearchResults = function (brandId, searchPhrase) {
                    lastSearchPhrase = searchPhrase;
                    var date = new Date();
                    var timeStamp = date.getTime();
                    scope.loading = true;
                    showResultsDropdown(true);
                    GlobalSearchDataManager.getSearchResult(hUser, searchPhrase).then(function (res) {
                        delete scope.loading;
                        scope.hits = res.hits;
                        scope.results = res.results;
                        resultIndex = -1;
                        hightLightCard();
                        if (scope.error) {
                            delete scope.error;
                        }



                    }, function (err) {
                        delete scope.loading;
                        scope.results = [];
                        scope.hits = 0;
                        scope.error = true;
                    })
                        .finally(function () {
                            showResultsDropdown(!scope.hideResult && scope.searchInput && scope.searchInput.length >= 3);
                            scope.$digest();
                        });
                }

                var showResultsDropdown = function (isShown) {
                    scope.searchDropdownToggeled({ isShown: !!isShown });
                };

                scope.isShowingResults = function () {
                    return !scope.hideResult && scope.searchInput && scope.searchInput.length >= 3;
                }

                scope.setFocusToInput = function () {
                    $("#search-input").focus();
                }

                scope.clickSearchButton = function () {
                    if (scope.searchInput && scope.searchInput.length) {
                        Utils.redirectToWorkspace(
                            'appLayout.harriSH.globalSearch',
                            {
                                search_phrase: (['.','..'].indexOf(scope.searchInput) === -1) ? scope.searchInput : " "
                            }
                        )
                    }

                    showResultsDropdown(false);

                    lastSearchPhrase = "";
                    setTimeout(function(){
                        scope.$digest();
                    }, 1)
                }
                scope.callbacks = {
                    clickSearchButton: scope.clickSearchButton,
                    hideSearchPreview: function () {
                        showResultsDropdown(false);
                    },
                }

                var searchTimeOutRefrence;
                var lastCheck = 0;
                scope.searchInputUpdated = function () {
                    scope.searchInput = scope.searchInput.trim();
                    scope.hideResult = false;
                    if (searchTimeOutRefrence) {
                        clearTimeout(searchTimeOutRefrence);
                    }
                    var date = new Date();
                    if (scope.searchInput.length >= 3 && scope.searchInput != lastSearchPhrase && scope.searchInput != "." && scope.searchInput != "..") {
                        if (Date.now() - lastCheck > whilePrintingTimeOutPeriod) {
                            lastCheck = Date.now();
                            getSearchResults(hUser.getUserContext().brand_id, scope.searchInput)
                        } else {
                            searchTimeOutRefrence = setTimeout(
                                function () {
                                    getSearchResults(hUser.getUserContext().brand_id, scope.searchInput)
                                }, searchTimeOutPeriod
                            )
                        }

                    } else {
                        if (scope.searchInput.length == 0) {
                            scope.results = [];
                            lastCheck = 0;
                            lastSearchPhrase = "";
                        }

                        showResultsDropdown(false);
                    }
                    setTimeout(function () {
                        scope.$digest()
                    }, 1)
                };


                scope.handleKeyPress = function ($e) {
                    switch ($e.keyCode) {
                        case KEYS.ENTER :
                            if (resultIndex == -1) {
                                scope.clickSearchButton();
                            } else {

                                // Work around to disable $scope.$digest twice.
                                setTimeout(function () {
                                    $($e.target).closest('.global-search-wrapper')
                                        .find('.search-results')
                                        .find('.search-result')
                                        .eq(resultIndex).find('a').click();
                                }, 100);
                            }
                            scope.hideResult = true;
                            showResultsDropdown(false);
                            break;
                        case KEYS.UP :
                            if (scope.results) {
                                resultIndex = (resultIndex > -1) ? (resultIndex - 1) : -1;
                                hightLightCard();
                            }
                            $e.preventDefault();
                            break;
                        case KEYS.DOWN :
                            if (scope.results) {
                                resultIndex = (scope.results && resultIndex < scope.results.length - 1) ? (resultIndex + 1) : scope.results.length - 1;
                                hightLightCard();
                            }
                            $e.preventDefault();
                            break;
                        case KEYS.ESC :
                            scope.hideResult = true;
                            showResultsDropdown(false);
                            break;
                    }
                };
                var hightLightCard = function () {

                    $(".search-result").removeClass("highlighted")
                    if (resultIndex >= 0 && resultIndex < scope.results.length) {
                        var id = scope.results[resultIndex]['id'];
                        $("#" + id).addClass("highlighted")
                    }
                };

                scope.clearSearch = function () {
                    scope.searchInput = "";
                    scope.searchInputUpdated();
                };

                scope.onViewReady();
            }
        }
    }]);
})();


